<template>
  <div
    class="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-x-4 border-b backdrop-blur-md border-neutral-200 bg-white/30 dark:bg-neutral-800/30 dark:border-neutral-700 px-4 shadow-xs sm:gap-x-6 sm:px-6 2xl:px-8">
    <button
      type="button"
      class="-m-2.5 p-2.5 text-neutral-700 dark:text-neutral-300 2xl:hidden"
      @click="$emit('open-sidebar')">
      <span class="sr-only">Open sidebar</span>
      <i class="fa-sharp fa-regular fa-bars fa-fw" aria-hidden="true"></i>
    </button>

    <!-- Separator -->
    <div class="h-6 w-px bg-neutral-900/10 2xl:hidden" aria-hidden="true" />

    <div class="flex flex-1 gap-x-4 self-stretch 2xl:gap-x-6">
      <NtHeaderSearch />
      <div class="flex items-center gap-x-4 2xl:gap-x-6">
        <NtHeaderDownloads />
        <NtHeaderNotifications />

        <!-- AI Assistant -->
        <NtHeaderAiAssistant />

        <!-- Separator -->
        <div class="hidden 2xl:block 2xl:h-6 2xl:w-px 2xl:bg-neutral-900/10" aria-hidden="true" />

        <!-- Profile dropdown -->
        <NtHeaderMenu />
      </div>
    </div>
  </div>
</template>

<script>
import NtHeaderDownloads from './NtHeaderDownloads.vue'
import NtHeaderSearch from './NtHeaderSearch.vue'
import NtHeaderNotifications from './NtHeaderNotifications.vue'
import NtHeaderMenu from './NtHeaderMenu.vue'
import NtHeaderAiAssistant from './NtHeaderAiAssistant.vue'

export default {
  components: {
    NtHeaderDownloads,
    NtHeaderSearch,
    NtHeaderNotifications,
    NtHeaderMenu,
    NtHeaderAiAssistant
  }
}
</script>
